import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import ReduxUseRecord from '../../../../store/actionreducers/useRecord';
import ReduxGroup from '../../../../store/actionreducers/group';
import {FusePageSimple} from '../../../../@fuse/index';
import UseRecordList from './UseRecordList';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import UecareListHeader from "../../../../components/header/UecareListHeader";
import UseRecordSideBar from "./UseRecordSideBar";

class VipUseRecordApp extends Component {

    async componentDidMount() {
        try {
            const groupId = this.props.match.params.groupId;

            if (groupId === 'all') {
                await this.props.getUseRecords();
            } else {
                await this.props.getGroup(groupId);
                await this.props.getUseRecordsByGroupId(groupId);
            }
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader
                            title='點數紀錄'
                            icon='search'
                            arrowBack={{
                                linkTo: '/apps/group/all',
                                label: '群組帳戶列表'
                            }}/>
                    }
                    leftSidebarContent={
                        <UseRecordSideBar sidebarType='group'/>
                    }
                    content={
                        <UseRecordList/>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <UecareAlertDialog/>
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    avatar: {},
    layoutHeader: {
        height: 160,
        minHeight: 160
    },
    layoutContentCardWrapper: {
        padding: 24,
        paddingBottom: 80
    },
    layoutLeftSidebar: {
        width: 246
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getGroup: ReduxGroup.ActionCreator.getGroup,
        getUseRecords: ReduxUseRecord.ActionCreator.getUseRecords,
        getUseRecordsByGroupId: ReduxUseRecord.ActionCreator.getUseRecordsByGroupId,
    }, dispatch);
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(null, mapDispatchToProps)(VipUseRecordApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/GroupUseRecordApp.js